import React, { useState } from "react"
import {
  header,
  burgerMenu,
  burgerMenuOpen,
  logoSite,
  headerSearch,
  searchButton,
  searchButtonActive,
  burgerMenuTitle,
  logoSiteImg,
} from "./header.module.scss"
import { BurgerSpan, SearchButton, LogoSite, MenuTitle } from "./header-styled"
import ImageFromDrupal from "gatsby-theme-blank/src/components/Image/image-from-drupal"
import PropTypes from "prop-types"
import Icon from "gatsby-theme-blank/src/components/Icon/icon"
import { useBuildData } from "gatsby-theme-blank/src/hooks/use-build-data"
import AniLink from "gatsby-plugin-transition-link/AniLink"
import { useHeader } from "gatsby-theme-blank/src/components/Layout/Header/header-query"
import MainMenu from "gatsby-theme-lantana/src/gatsby-theme-blank/components/Layout/Header/MainMenu/main-menu"
import MainSearch from "./MainSearch/main-search"

//-----------------------Parent component---------------------------//

const Header = ({ children, isGdd, isIndex }) => {
  const buildColors = useBuildData().theme_settings.palette
  const buildInfos = useBuildData().site_settings
  const data = useHeader()
  const [openBurger, setOpenBurger] = useState(false)
  const [openSearch, setOpenSearch] = useState(false)
  const menuData = data.allMenuLinkContentMenuLinkContent.edges
  return (
    <>
      {!isGdd && (
        <header className={header}>
          <div
            tabIndex={0}
            role="button"
            className={!openBurger ? burgerMenu : burgerMenuOpen}
            onClick={() => setOpenBurger(!openBurger)}
            onKeyDown={() => setOpenBurger(!openBurger)}
          >
            <BurgerSpan></BurgerSpan>
            <BurgerSpan></BurgerSpan>
            <BurgerSpan></BurgerSpan>
            <BurgerSpan></BurgerSpan>
          </div>
          <MenuTitle
            tabIndex={0}
            role="button"
            onClick={() => setOpenBurger(!openBurger)}
            onKeyDown={() => setOpenBurger(!openBurger)}
            className={burgerMenuTitle}
          >
            Menu
          </MenuTitle>
          <LogoSite className={logoSite}>
            <AniLink
              aria-label="Logo accueil"
              paintDrip
              hex={buildColors.b_color_gradients.b_dark}
              to="/"
            >
              {buildInfos.website_logo.fid === null ? (
                <Icon size={48} icon="home" />
              ) : (
                <ImageFromDrupal
                  className={logoSiteImg}
                  alt={"Logo " + buildInfos.website_name}
                  drupal_fid={buildInfos.website_logo.fid}
                />
              )}
            </AniLink>
          </LogoSite>
          <MainMenu colors={buildColors} mainMenuData={menuData} />
          <div className={headerSearch}>
            <SearchButton
              aria-label="Bouton de recherche"
              role="button"
              tabIndex={0}
              className={!openSearch ? searchButton : searchButtonActive}
              activeSearch={searchButtonActive}
              onClick={() => setOpenSearch(!openSearch)}
              onKeyDown={() => setOpenSearch(!openSearch)}
            >
              <Icon icon="search" size={22}></Icon>
            </SearchButton>
          </div>
        </header>
      )}
      <MainSearch isIndex={isIndex} open={openSearch}>
        {children}
      </MainSearch>
    </>
  )
}
//-----------------------Parent component---------------------------//

//-----------------------Prop-Types---------------------------//

Header.propTypes = {
  children: PropTypes.node.isRequired,
  isGdd: PropTypes.bool,
  isIndex: PropTypes.bool,
}

//-----------------------Prop-Types---------------------------//

export default Header
